import createApi from '@/services/Api';
import moment from 'moment';
import store from '@/store';
import jwt_decode from 'jwt-decode';
import { dictUser, isTokenExpired } from './util';

function Auth() {
  const api = createApi();

  function getUserFromToken(token) {
    const decoded = jwt_decode(token);

    if (isTokenExpired(decoded.exp)) {
      throw new Error('Token expired');
    }

    return dictUser({ ...decoded, token });
  }

  function getUserConfigs() {
    const endpoint = '/profissional-saude/clinica/configuracoes';
    return api.get(endpoint);
  }

  function getServiceProfile() {
    return api.get('/profissional-saude/dashboard/perfis-atendimento');
  }

  function fetchMemedAuth() {
    const endpoint =
      '/profissional-saude/profissionais/status-integracao-memed';

    return api.get(endpoint, {
      transformResponse: [
        ...api.defaults.transformResponse,
        data => {
          const { memedAtivo, token } = data.object;

          return { ...data, object: { actived: memedAtivo, token } };
        },
      ],
    });
  }

  function setMemedLocalAuth({ token, actived }) {
    const { id } = store.getters['dashboard/currWorkspace'];
    const auths = JSON.parse(localStorage.getItem('memedAuth')) || {};

    localStorage.setItem(
      'memedAuth',
      JSON.stringify({
        ...auths,
        [id]: { token, timestamp: moment().valueOf(), actived },
      }),
    );
  }

  function getMemedLocalAuth() {
    const { id } = store.getters['dashboard/currWorkspace'];
    const auths = JSON.parse(localStorage.getItem('memedAuth'));
    if (!auths || !id) return null;

    return auths[id];
  }

  async function getMemedAuth(forceFetch) {
    const localAuth = getMemedLocalAuth();

    if (localAuth?.timestamp && !forceFetch) {
      const now = moment(),
        from = moment(localAuth.timestamp);

      if (now.isSame(from, 'hour')) {
        const { timestamp, ...localAuthRest } = localAuth;
        return Promise.resolve({ ...localAuthRest, isLocal: true });
      }
    }

    try {
      const response = await fetchMemedAuth();
      setMemedLocalAuth(response.data.object);

      return Promise.resolve(response.data.object);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  return {
    getUserConfigs,
    getMemedAuth,
    getUserFromToken,
    getServiceProfile,
  };
}

export default Auth();
